module.exports = __webpack_public_path__ + "static/media/summernote.7e263200.eot";